import { settingsController } from 'reactApp/modules/settings/settings.controller';
import { sendGa } from 'reactApp/utils/ga';

export const sendAttachesGa = (action, label = '', iData = null) => {
    const viewMode = settingsController.getViewMode();
    sendGa(`attaches-${viewMode}`, action, label, iData);
};
